import React from 'react';

interface BackgroundProps {
  isMenuOpen: boolean;
}

export const Background: React.FC<BackgroundProps> = ({ isMenuOpen }) => {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
      {/* Base Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary to-primary-dark transition-colors duration-700"></div>

      {/* Decorative Orbs - Screen 1 Style */}
      <div 
        className={`absolute -top-[20%] -right-[20%] w-[80%] h-[50%] bg-white/5 blur-[80px] rounded-full transition-opacity duration-700 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}
      />
      <div 
        className={`absolute top-0 left-0 w-full h-[60%] bg-gradient-to-b from-white/10 to-transparent transition-opacity duration-700 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`} 
      />

      {/* Decorative Orbs - Screen 2 Style (Menu Open) */}
      <div 
        className={`absolute -top-[20%] -left-[10%] w-[70%] h-[70%] bg-blue-400/20 rounded-full blur-[100px] transition-all duration-700 ease-in-out ${isMenuOpen ? 'opacity-60 translate-y-0' : 'opacity-0 -translate-y-10'}`} 
      />
      <div 
        className={`absolute top-[30%] right-[-20%] w-[80%] h-[80%] bg-indigo-600/30 rounded-full blur-[120px] transition-all duration-700 ease-in-out ${isMenuOpen ? 'opacity-60 translate-y-0' : 'opacity-0 translate-y-10'}`} 
      />

      {/* Dark overlay when menu is open */}
      <div 
        className={`absolute inset-0 bg-black/30 backdrop-blur-[2px] transition-opacity duration-500 ${isMenuOpen ? 'opacity-100' : 'opacity-0'}`} 
      />
    </div>
  );
};